// extracted by css-extract-rspack-plugin
var _1 = "vKxkHboaszEJyeo4";
var _2 = "vKxkHboaszEJyeo4";
var _3 = "wQkFTzDhOHsQIRz8";
var _4 = "_WleWKTcUEYlExCz";
var _5 = "wQkFTzDhOHsQIRz8";
var _6 = "_WleWKTcUEYlExCz";
export { _1 as "buttons-wrapper", _2 as "buttonsWrapper", _3 as "title--sticky", _4 as "title--with-buttons", _5 as "titleSticky", _6 as "titleWithButtons" }
